// 统一导出常用派生状态，页面尽量通过 getters 读取 store 数据。
const getters = {
    appName: (state) => state.app.name,
    appEnv: (state) => state.app.env,
}

export default getters
